import http from '@/http'

const API_PATH = 'user/account/'

const state = {
  account: null
}

const getters = {
  account: state => state.account
}

const mutations = {
  account(state, payload) {
    state.account = payload
  }
}

const actions = {
  async show({ commit }) {
    await http.get(API_PATH).then(response => {
      const licensedPlan = response.data.included.filter(resource => resource.type === 'licensedPlan')[0].attributes
      const reservedRoom = response.data.included.filter(resource => resource.type === 'reservedRoom')[0]
      licensedPlan.licensedRoomOptions = response.data.included.filter(resource => resource.type === 'licensedRoomOption').map(resource => resource.attributes)
      commit('account', Object.assign(
        response.data.data.attributes,
        {
          licensedPlan: licensedPlan,
          reservedRoom: reservedRoom ? reservedRoom.attributes : null
        }
      ))
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
